





























import { Component, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
import { RenderTemplateModel, RenderContentModel } from "@/services/render/types";
import SolutionRender from "@/components/render/SolutionRender.vue";
import { Getter } from "vuex-class";
import PreviewModalHeader from "@/components/common/preview/PreviewModalHeader.vue";
import PreviewSidebar from "@/components/common/preview/PreviewSidebar.vue";

const namespace: string = "authentication";

@Component({
    components: {
        SolutionRender,
        PreviewModalHeader,
        PreviewSidebar
    }
})
export default class SolutionPreviewModal extends Vue {
    @Getter("getToken", { namespace }) getToken!: string;

    // local
    solutionId = "";
    solutionTimezoneId = "";
    width = 0;
    height = 0;

    dateTime = "";
    scale = 1;
    fitScale = 0;
    bgColor = "#ffffff";
    name = "";
    allowTransition = false;

    open(solutionId: string, solutionTimezoneId:string, width: number, height: number, name: string) {
        this.allowTransition = false;
        this.name = name;
        this.width = width;
        this.height = height;
        this.solutionId = solutionId;
        this.solutionTimezoneId = solutionTimezoneId;
        this.setScale();
        this.$bvModal.show("modal-boardPreview");
    }

    hide() {
        this.$bvModal.hide("modal-boardPreview");
    }

    renderSolution(value: string) {
        this.dateTime = value;
    }

    fullScreen() {
        return { name: "previewSolution", params: { solutionId: this.solutionId } };
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    setScale() {
        var scaleX = (window.innerWidth / 100 * 70) / this.width;
        var scaleY = (window.innerHeight / 100 * 74) / this.height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.floor(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    onScale(value: number) {
        this.scale = value;
        this.allowTransition = true;
    }

    // computed

    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.height}px`,
            width: `${this.width}px`
        };
    }
}
